import { ErrorCodes } from './../../@core/http/models';
import { BackendResponseModel } from './../../@core/http/models/backend-response.model';
import { ReportGenerateRequest } from '../models/report-generate-request';
import { ReportStatus } from '../models/report-status.enum';
import { Injectable } from '@angular/core';
import { MwHttpService } from './../../@core/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { environment } from 'environments/environment';
import { ReportStatusViewModel } from 'app/models/report-status-view.model';

@Injectable({ providedIn: 'root' })
export class ReportApiService {
  constructor(private http: MwHttpService) {}

  getReportStatus(
    token: string,
    relativePath: boolean = false
  ): Observable<ReportStatusViewModel> {
    return this.http
      .authGet<ReportStatusViewModel>(
        environment.reportsServiceEndpoint +
          `/../status/${token}?_${+new Date()}&isRelativePath=${relativePath}`,
        {
          ignoreNotifyStatusCodes: [404],
        }
      )
      .pipe(
        catchError((err) => {
          if (
            err instanceof BackendResponseModel &&
            err.errors.length === 1 &&
            err.errors[0].errorCode === ErrorCodes.NotFound
          ) {
            return of({ status: ReportStatus.None });
          }
          return throwError(err);
        })
      );
  }

  generateReport(
    reportGenerateRequest: ReportGenerateRequest
  ): Observable<Blob> {
    return this.http.authPost<Blob>(
      environment.reportsServiceEndpoint + `/../generate`,
      {
        body: reportGenerateRequest,
        responseType: 'blob',
        ignoreNotifyStatusCodes: [404],
      }
    );
  }

  downloadReport(
    token: string,
    path: string,
    fileName: string,
    format: 'PDF' | 'XLSX' = 'PDF'
  ): Observable<ReportStatus> {
    return this.http
      .authPost<Blob>(
        environment.reportsServiceEndpoint + `/../download/${token}`,
        {
          body: {
            token,
            path,
            parameters: {
              Format: format,
            },
          },
          responseType: 'blob',
          ignoreNotifyStatusCodes: [404],
        }
      )
      .pipe(
        tap((blob) => {
          saveAs(blob, fileName);
        }),
        map(() => ReportStatus.Completed)
      );
  }
}
